<template>
  <v-row
    class="elevation-4 px-4 mx-1 py-1 mb-4 mt-n2 white"
    dense
  >
    <template v-if="displayHeader">
      <v-col :cols="selectable || deleteScenario ? 6 : 12">
        <b class="text-capitalize">{{ $t('scenario.scenario') }} {{ scenario.id }} - level: {{ scenario.level }} </b>
        <v-icon
          v-if="enableResolvedCheckMark && scenario.extend === 'false'"
          dense
          color="success"
        >
          mdi-check
        </v-icon>
      </v-col>
      <v-col v-if="selectable" cols="6">
        <v-btn
          class="float-right"
          fab
          small
          dark
          :color="selected ? 'green' : 'grey'"
        >
          <v-icon v-if="scenario.selectLoading" dark large class="rai-custom-loader__button">mdi-cached</v-icon>
          <v-icon v-else dark large>mdi-check</v-icon>
        </v-btn>
      </v-col>
      <v-col v-if="deleteScenario" cols="6">

        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              @click="deleteScenarioFunction(preference.id)"
              class="float-right"
              icon
              v-bind="attrs"
              v-on="on"
              >
              <v-icon color="grey">
                mdi-close
              </v-icon>
            </v-btn>
          </template>
          <span>{{ $t('scenario.removeScenario') }}</span>
        </v-tooltip>

      </v-col>
    </template>
    <v-col cols="12">
      <v-tooltip 
        v-if="!isEditingScenario" 
        bottom
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-if="allowSetUp"
            @click="setUpScenario"
            class="float-right"
            icon
            v-bind="attrs"
            v-on="on"
          >
            <v-icon color="grey">
              mdi-beaker-plus
            </v-icon>
          </v-btn>
        </template>
        <span>{{ $t('scenario.addOptionsToExistingScenario') }}</span>
      </v-tooltip>
      <v-tooltip 
        v-if="!isEditingScenario" 
        bottom
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-if="allowIncompatible"
            @click="icompatibleScenario()"
            class="float-right"
            icon
            v-bind="attrs"
            v-on="on"
          >
            <v-icon color="grey">
              mdi-arrow-collapse
            </v-icon>
          </v-btn>
        </template>
        <span>{{ $t('scenario.incompatibles') }}</span>
      </v-tooltip>
      <v-tooltip 
        v-if="!isEditingScenario" 
        bottom
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-if="allowScenarioEdition"
            @click="edit()"
            class="float-right"
            icon
            v-bind="attrs"
            v-on="on"
          >
            <v-icon color="grey">
              mdi-pencil-outline
            </v-icon>
          </v-btn>
        </template>
        <span>{{ $t('scenario.editExistingScenario') }}</span>
      </v-tooltip>
      <template v-if="isEditingScenario">
        <input-scenario-elements
          :create-new-scenario=false
          :available-elements="availableElements"
          :update-available-elements="updateAvailableElements"
          :update-available-scenarios="updateAvailableScenarios"
          :selected-elements="scenario.elements"
          v-on="$listeners"
          :cancel-scenario-edition="removeScenarioEditionForm"
          :successful-scenario-update="removeScenarioEditionForm"
          :scenario="scenario"
        />
      </template>
      <template v-else>
          <element-chip
            v-for="(element, index) in scenario.elements"
            :close-function="deleteElementFunction"
            :close-function-parameters="option ? [option, scenario, element] : [scenario, element]"
            :close="deleteElement"
            :key="'elt_' + index"
            :element="element"
            :edit="editElement"
            :edit-function="editElementFunction"
            :edit-function-parameters="[element]"
          />
      </template>
      <v-chip
        v-for="(element, index) in scenario.informations"
        :key="'info_' + index"
        outlined
        color="black"
        class="px-5 pt-0 mr-1 my-1 font-weight-bold"
      >
        {{ !showLogicalLanguage ? (element.name ? element.name : $t('global.notranslation')) : (element.prolog ? element.prolog : $t('global.notranslation')) }}
      </v-chip>

      <v-menu offset-y max-height="600px">
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-show="scenarios.length > 0 && !disableDropDownList"
            class="float-right"
            fab
            icon
            small
            dark
            color="grey"
            v-bind="attrs"
            v-on="on"
          >
            <v-icon dark large>mdi-chevron-down</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item
            v-for="(item, index) in scenarios"
            :key="index"
            @click="changeSelectedScenario(item)"
            class="rai-scenario__block"
          >
            <v-list-item-title>
              <scenario-block
                :scenario="item"
                v-on="$listeners"
              />
            </v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-col>
  </v-row>
</template>

<script>
import ElementChip from '@/components/global/ElementChip';
import InputScenarioElements from '@/components/global/InputScenarioElements';

export default {
  name: 'ScenarioBlock',

  components: { ElementChip, InputScenarioElements },

  data () {
    return {
      isEditingScenario: false,
    };
  },

  props: {
    displayHeader: {
      type: Boolean,
      required: false,
      default: true,
    },
    option: {
      type: Object,
      required: false,
      default: undefined,
    },
    scenario: {
      type: Object,
      required: true,
    },
    selectable: {
      type: Boolean,
      required: false,
      default: false,
    },
    selected: {
      type: Boolean,
      required: false,
      default: false,
    },
    scenarios: {
      type: Array,
      required: false,
      default: () => [],
    },
    deleteScenario: {
      type: Boolean,
      required: false,
      default: false,
    },
    deleteScenarioFunction: {
      type: Function,
      required: false,
      default: () => {},
    },
    deleteElement: {
      type: Boolean,
      required: false,
      default: false,
    },
    deleteElementFunction: {
      type: Function,
      required: false,
      default: () => {},
    },
    editElement: {
      type: Boolean,
      required: false,
      default: false,
    },
    editElementFunction: {
      type: Function,
      required: false,
      default: () => {},
    },
    allowSetUp: {
      type: Boolean,
      required: false,
      default: false,
    },
    allowIncompatible: {
      type: Boolean,
      required: false,
      default: false,
    },
    allowScenarioEdition: {
      type: Boolean,
      required: false,
      default: false,
    },
    availableElements: {
      type: Array,
      required: false,
      default: () => [],
    },
    updateAvailableElements: {
      type: Function,
      required: false,
      default: () => {},
    },
    updateAvailableScenarios: {
      type: Function,
      required: false,
      default: () => {},
    },
    emitEvent: {
      type: Function,
      required: false,
      default: () => {},
    },
    preference: {
      type: Object,
      required: false,
    },
    disableDropDownList: {
      type: Boolean,
      required: false,
      default: false
    },
    enableResolvedCheckMark: {
      type: Boolean,
      required: false,
      default: true,
    }
  },

  methods: {
    changeSelectedScenario (event) {
      this.$emit('changeScenario', event);
    },

    setUpScenario () {
      this.$router.push({name: 'addOptionsToScenario', params: { id: this.$route.params.id, scenarioId: this.scenario.id } });
    },

    icompatibleScenario () {
      this.$router.push({name: 'incompatibleScenarii', params: { id: this.$route.params.id, scenarioId: this.scenario.id } });
    },

    edit () {
      this.isEditingScenario = true;
    },

    removeScenarioEditionForm () {
      this.isEditingScenario = false;
    },
  },
};
</script>

<style>
.rai-scenario__block .v-list-item__title {
  padding-top: 10px;
}
</style>